import { Injectable } from "@angular/core";
import { USERINFO, USERPERMISSIONS } from "src/app/permissions/authPermissions";

export enum PERMISSIONS {
  Home = 1,
  KeyCenter = 2,
  AccessManagement = 5,
  Monitoring = 9,
  Reports = 11,
  File = 15,
  Language = 20,
  View = 30,
  MonitoringSettings = 40,

  ClientDashBoard = 100,
  ExpressCheckin = 200,
  ECHeckin,
  EDeleteCard,
  EReadCard,
  EMobileCheckin,
  EAddCard,
  EView,

  CheckinOut = 300,
  CCHeckin,
  CDeleteCard,
  CReadCard,
  CMobileCheckin,
  CAddCard,
  CCardLost,
  CCheckOut,
  CView,

  LostBlockCard = 400,
  LCardFound,
  LDeleteCard,
  LReadCard,
  LBlockCard,
  LUnblockCard,
  LView,

  AccessRights = 500,
  ArReports,
  ArCreate,
  ArDelete,
  ArUpdate,
  ArLink,
  ArUnlink,
  ArBulkAct,

  AccessProfiles = 600,
  ApReports,
  ApCreate,
  ApDelete,
  ApUpdate,
  ApLink,
  ApUnlink,
  ApBulkAct,

  AccessCards = 700,
  AcReports,
  AcCreate,
  AcDelete,
  AcUpdate,
  AcLink,
  AcUnlink,
  AcBulkAct,

  PerMgt = 800,
  PerReports,
  PerCreate,
  PerDelete,
  PerUpdate,
  PerLink,
  PerUnlink,
  PerBulkAct,

  RealTimeEvt = 900,
  DrMonitoring = 920,
  DrDnd,
  DrMur,
  DrMore,
  DrFreeP,
  DrReval,
  DrBlock,
  UpdLp,

  APMonitoring = 1000,
  APDnd,
  ApMur,
  ApMore,
  ApFreeP,
  ApReval,
  ApBlock,
  ApdLp,

  SystemAudit = 1100,
  SExpPdf,
  SExpWord,
  SExpExcel,

  DoorEvent = 1200,
  DExpPdf,
  DExpWord,
  DExpExcel,

  Themes = 1300,
  Theme1,
  Theme2,
  Theme3,

  CheckForUpdate,
  SaveSettings,
  About,

  Views = 1400,
  ShowEvt,
  CloseEvt,

  ContentView,
  EnableDisnableTouch,
  Font,
  DoorViewSize,

  MaxColumn,
  MaxRows,

  DASHBOARD = 4100,
  DEFAULT = 4101,
  SUMMARY = 4102,
  SKYACCESS = 4103,
  SYSTEM = 4120,
  DEFAULTSETTING = 4121,
  RFIDSETTING = 4122,
  SKYACCESSMOBILE = 4140,
  HOTEL = 4141,
  EMAILTEMANAGEMENT = 4160,
  EMAILTEMPLATE = 4161,
  SKYACCESSKEYS = 4162,
  SUPPORTCENTER = 4163,
  HARDWARETEMPLATE = 4180,
  ILOCKTEMPLATE = 4181,
  WALLREADER = 4182,
  DOORSETUP = 4200,
  SERVICEAUTH = 4201,
  DOORSCHEDULER = 4202,
  DOORWEKKLYPROGRAM = 4203,
  DOORMANAGEMENT = 4204,
  DOORRELATIONSHIP = 4205,
  GUESTCARDMANGEMENT = 4220,
  CHECKINGUEST = 4221,
  REROOM = 4222,
  CHECKEDINGUEST = 4223,
  ONDOORCHECKIN = 4224,
  LOSTBLOCKCARD = 4225,
  STAFFCARDMANAGEMENT = 4240,
  STAFFVISITOR = 4241,
  LOSTBLOCKCARDS = 4242,
  ACCESSMANAGEMENT = 4260,
  ACCESSRIGHT = 4261,
  ACCESSPROFILES = 4262,
  PERSONS = 4263,
  ACCESSCARDS = 4264,
  OPERATORMANAGEMENT = 4280,
  ROLESPERMISSION = 4281,
  OPERATORASSIGNMENT = 4282,
  INTEGRACLIENTS = 4283,
  CLIENTROLESPERMISSION = 4284,
  CLIENTASSIGNMENT = 4285,
  MONITORING = 4300,
  DOORMONITORING = 4301,
  ACCESSPOINTMONITORING = 4302,
  WIRELESSCHART = 4303,
  BATTERYCHART = 4304,
  COMMUNICATIONSETTING = 4320,
  PMSSETTING = 4321,
  ACCESSPOINTSETTINGS = 4323,
  CALENDARMANAgement = 4340,
  CALENDAR = 4341,
  DSD = 4342,
  SPECIALDAYS = 4343,
  EVENTLOG = 4360,
  DOOREVENTS = 4361,
  SYSTEMEVENTS = 4362,
  HOUSEKEEPING = 4380,
  DATABASEBACKUP = 4381,
  SYSTEMEVENT = 4382,
  PARKING = 4400,
  ISSUECARD = 4401,
  OVERVIEW = 4402,
  EVENTS = 4403,
  CLIENTBUILDING = 4404,
  MANAGEMENT = 4405,
}

export interface NavigationItem {
  id: string;
  title: string;
  type: "item" | "collapse" | "group";
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
  // Temp
  Links: string;
  VarTxt: string;
  Classes: string;
  ID: string;
  MenuID: PERMISSIONS;
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

@Injectable()
export class NavigationItem {
  public static NavigationItems = [
    {
      id: "navigation",
      title: "Navigation",
      type: "group",
      icon: "fa fa-th",

      children: [
        {
          id: "dashboard",
          title: "dashboard",
          type: "collapse",
          icon: "fa fa-th",
          hidden: true,
          MenuID: PERMISSIONS.DASHBOARD,
          children: [
            {
              id: "default",
              title: "d_default",
              type: "item",
              url: "/dashboard/default",
              hidden: true,
              MenuID: PERMISSIONS.DEFAULT,
            },
            {
              id: "summary",
              title: "d_summary",
              type: "item",
              url: "/dashboard/summary",
              hidden: true,
              MenuID: PERMISSIONS.SUMMARY,
            },
            {
              id: "crm",
              title: "d_skyAccess",
              type: "item",
              url: "/dashboard/crm",
              hidden: true,
              MenuID: PERMISSIONS.SKYACCESS,
            },
          ],
        },
        {
          id: "system",
          title: "system",
          type: "collapse",
          icon: "fa fa-cogs",
          hidden: true,
          MenuID: PERMISSIONS.SYSTEM,
          children: [
            {
              id: "default-settings",
              title: "s_defaultSettings",
              type: "item",
              url: "/system/default-settings",
              hidden: true,
              MenuID: PERMISSIONS.DEFAULTSETTING,
            },
            {
              id: "rfid-card-settings",
              title: "s_rfidCardSettings",
              type: "item",
              url: "/system/rfid-card-settings",
              hidden: true,
              MenuID: PERMISSIONS.RFIDSETTING,
            },
          ],
        },
        {
          id: "skyaccess",
          title: "skyAccess",
          type: "collapse",
          icon: "fa fa-cloud",
          hidden: true,
          MenuID: PERMISSIONS.SKYACCESSMOBILE,
          children: [
            {
              id: "hotel",
              title: "s_hotel",
              type: "item",
              url: "/skyaccess/hotel",
              hidden: true,
              MenuID: PERMISSIONS.HOTEL,
            },
            {
              id: "myamadeodesign",
              title: "s_myamadeodesign",
              type: "item",
              url: "/skyaccess/myamadeodesign",
              hidden: true,
              MenuID: PERMISSIONS.SKYACCESSMOBILE,
            },
            // {
            //   id: 'access-control',
            //   title: 'Access Control',
            //   type: 'item',
            //   url: '/skyaccess/access-control'
            //   MenuID: PERMISSIONS.ACCESSCONTROL,
            // },
            // {
            //   id: "residential",
            //   title: "s_residential",
            //   type: "item",
            //   url: "/skyaccess/residential",
            //   MenuID: PERMISSIONS.RESIDENTIAL,
            // },
          ],
        },
        {
          id: "emails",
          title: "emailManagement",
          type: "collapse",
          icon: "fa fa-envelope",
          hidden: true,
          MenuID: PERMISSIONS.EMAILTEMANAGEMENT,
          // badge: {
          //   title: '3',
          //   type: 'label-info'
          // },
          children: [
            {
              id: "email-templates",
              title: "e_emailTemplates",
              type: "item",
              url: "/emails/email-templates",
              hidden: true,
              MenuID: PERMISSIONS.EMAILTEMPLATE,
            },
            {
              id: "skyaccess-keys",
              title: "e_skyAccessKeys",
              type: "item",
              url: "/emails/skyaccess-keys",
              hidden: true,
              MenuID: PERMISSIONS.SKYACCESSKEYS,
            },
            // {
            //   id: 'alarms',
            //   title: 'Alarms and alert',
            //   type: 'item',
            //   url: '/emails/alarms',
            // MenuID: PERMISSIONS.ALARMSANDALERT,
            // },
            {
              id: "support-center",
              title: "e_supportCenter",
              type: "item",
              url: "/emails/support-center",
              hidden: true,
              MenuID: PERMISSIONS.SUPPORTCENTER,
            },
          ],
        },

        // {
        //   id: "hardware-templates",
        //   title: "hardwareTemplates",
        //   type: "collapse",
        //   icon: "fa fa-wrench",
        //   hidden: true,
        //   MenuID: PERMISSIONS.HARDWARETEMPLATE,
        //   children: [
        //     {
        //       id: "ilock-template",
        //       title: "h_ilock",
        //       type: "item",
        //       url: "/hardware-templates/ilock-template",
        //       hidden: true,
        //       MenuID: PERMISSIONS.ILOCKTEMPLATE,
        //     },
        //     {
        //       id: "wall-reader-template",
        //       title: "h_wallReader",
        //       type: "item",
        //       url: "/hardware-templates/wall-reader-template",
        //       hidden: true,
        //       MenuID: PERMISSIONS.WALLREADER,
        //     },
        //     // {
        //     //   id: 'door-manager-template',
        //     //   title: 'h_doorManager',
        //     //   type: 'item',
        //     //   url: '/hardware-templates/door-manager-template'
        //     // MenuID: PERMISSIONS.DOORMANAGERTEMPLATE,
        //     // },
        //     // {
        //     //   id: 'elevator-template',
        //     //   title: 'Elevator Template',
        //     //   type: 'item',
        //     //   url: '/hardware-templates/elevator-template'
        //     // MenuID: PERMISSIONS.ELEVATORMANAGER,
        //     // },
        //     // {
        //     //   id: 'energy-saver-template',
        //     //   title: 'Energy saver Template',
        //     //   type: 'item',
        //     //   url: '/hardware-templates/energy-saver-template'
        //     // MenuID: PERMISSIONS.ENERGYSAVERTEMPLATE,
        //     // },
        //     // {
        //     //   id: 'silocker-template',
        //     //   title: 'Silocker Template',
        //     //   type: 'item',
        //     //   url: '/hardware-templates/silocker-template'
        //     // MenuID: PERMISSIONS.ILOCKTEMPLATE,
        //     // },
        //   ],
        // },

        // {
        //   id: "Doors Setups",
        //   title: "doorSetups",
        //   type: "collapse",
        //   icon: "fa fa-lock",
        //   hidden: true,
        //   MenuID: PERMISSIONS.DOORSETUP,
        //   children: [
        //     {
        //       id: "Services-Auth",
        //       title: "d_service",
        //       type: "item",
        //       url: "/doors-setups/services-auth",
        //       hidden: true,
        //       MenuID: PERMISSIONS.SERVICEAUTH,
        //     },
        //     {
        //       id: "door-scheduler",
        //       title: "d_doorScheduler",
        //       type: "item",
        //       url: "/doors-setups/door-scheduler",
        //       hidden: true,
        //       MenuID: PERMISSIONS.DOORSCHEDULER,
        //     },
        //     {
        //       id: "door-weekly-program",
        //       title: "d_doorWeeklyProgram",
        //       type: "item",
        //       url: "/doors-setups/door-weekly-program",
        //       hidden: true,
        //       MenuID: PERMISSIONS.DOORWEKKLYPROGRAM,
        //     },
        //     {
        //       id: "door-management",
        //       title: "d_doorManagement",
        //       type: "item",
        //       url: "/doors-setups/door-management",
        //       hidden: true,
        //       MenuID: PERMISSIONS.DOORMANAGEMENT,
        //     },
        //     // {
        //     //   id: 'door-groups',
        //     //   title: 'Door Groups',
        //     //   type: 'item',
        //     //   url: '/doors-setups/door-groups'
        //     // },
        //     {
        //       id: "door-relationship",
        //       title: "d_doorRelationship",
        //       type: "item",
        //       url: "/doors-setups/door-relationship",
        //       hidden: true,
        //       MenuID: PERMISSIONS.DOORRELATIONSHIP,
        //     },
        //   ],
        // },

        {
          id: "Products Setups",
          title: "productsSetups",
          type: "collapse",
          icon: "fa fa-lock",
          hidden: true,
          MenuID: PERMISSIONS.DOORSETUP,
          children: [
            {
              id: "calender",
              title: "p_calender",
              type: "item",
              url: "/products-setups/calender",
              hidden: true,
              MenuID: PERMISSIONS.SERVICEAUTH,
            },
            {
              id: "special-days",
              title: "p_special_days",
              type: "item",
              url: "/products-setups/special-days",
              hidden: true,
              MenuID: PERMISSIONS.SERVICEAUTH,
            },
            {
              id: "dsd",
              title: "p_dsd",
              type: "item",
              url: "/products-setups/dsd",
              hidden: true,
              MenuID: PERMISSIONS.SERVICEAUTH,
            },
            {
              id: "Services-Auth",
              title: "p_services_auth",
              type: "item",
              url: "/products-setups/services-auth",
              hidden: true,
              MenuID: PERMISSIONS.SERVICEAUTH,
            },
            {
              id: "door-scheduler",
              title: "p_scheduler",
              type: "item",
              url: "/products-setups/scheduler",
              hidden: true,
              MenuID: PERMISSIONS.DOORSCHEDULER,
            },
            {
              id: "door-weekly-program",
              title: "p_weekly_program",
              type: "item",
              url: "/products-setups/weekly-program",
              hidden: true,
              MenuID: PERMISSIONS.DOORWEKKLYPROGRAM,
            },
            {
              id: "hardware-pattern",
              title: "p_hardware_pattern",
              type: "item",
              url: "/products-setups/hardware-pattern",
              hidden: true,
              MenuID: PERMISSIONS.DOORWEKKLYPROGRAM,
            },
            {
              id: "door-management",
              title: "p_product_list",
              type: "item",
              url: "/products-setups/product-list",
              hidden: true,
              MenuID: PERMISSIONS.DOORMANAGEMENT,
            },
            // {
            //   id: 'door-groups',
            //   title: 'Door Groups',
            //   type: 'item',
            //   url: '/doors-setups/door-groups'
            // },
            {
              id: "door-relationship",
              title: "p_product_relationship",
              type: "item",
              url: "/products-setups/product-relationship",
              hidden: true,
              MenuID: PERMISSIONS.DOORRELATIONSHIP,
            },
          ],
        },

        {
          id: "reception",
          title: "reception",
          type: "collapse",
          icon: "fa fa-key",
          hidden: true,
          MenuID: PERMISSIONS.GUESTCARDMANGEMENT,
          children: [
            // {
            //   id: "guest-checkin",
            //   title: "g_guests",
            //   type: "item",
            //   url: "/guests",
            //   hidden: true,
            //   MenuID: PERMISSIONS.CHECKINGUEST,
            // },
            {
              id: "guest-checkin",
              title: "r_guestCheckin",
              type: "item",
              url: "/reception/guest-checkin",
              hidden: true,
              MenuID: PERMISSIONS.CHECKINGUEST,
            },
            {
              id: "new-guest-check-in",
              title: "r_newGuestCheckin",
              type: "item",
              url: "/reception/re-rooming",
              hidden: true,
              MenuID: PERMISSIONS.REROOM,
              // badge: {
              //       title: 'NEW',
              //       type: 'label-danger'
              //     }
            },
            {
              id: "guest-management",
              title: "r_guestMgt",
              type: "item",
              url: "/reception/checked-in-guest",
              hidden: true,
              MenuID: PERMISSIONS.CHECKEDINGUEST,
            },
            {
              id: "on-door-check-in",
              title: "r_onDoorCheckin",
              type: "item",
              url: "/reception/on-door-check-in",
              hidden: true,
              MenuID: PERMISSIONS.ONDOORCHECKIN,
            },
            {
              id: "lost-block-cards",
              title: "r_lostBlockCards",
              type: "item",
              url: "/reception/lost-block-cards",
              hidden: true,
              MenuID: PERMISSIONS.LOSTBLOCKCARD,
            },
          ],
        },

        {
          id: "staff",
          title: "staff",
          type: "collapse",
          icon: "fas fa-users",
          hidden: true,
          MenuID: PERMISSIONS.STAFFCARDMANAGEMENT,
          children: [
            {
              id: "staff-management",
              title: "s_staffMgt",
              type: "item",
              url: "/reception/staff-management",
              hidden: true,
              MenuID: PERMISSIONS.STAFFVISITOR,
            },
            {
              id: "staff-lost-block-cards",
              title: "s_lostBlockCards",
              type: "item",
              url: "/reception/staff-lost-block-cards",
              hidden: true,
              MenuID: PERMISSIONS.LOSTBLOCKCARDS,
            },
          ],
        },

        {
          id: "access-management",
          title: "accessMgt",
          type: "collapse",
          icon: "fa fa-id-card",
          hidden: true,
          MenuID: PERMISSIONS.ACCESSMANAGEMENT,
          children: [
            {
              id: "access-rights",
              title: "a_accessRights",
              type: "item",
              url: "/access-management/access-rights",
              hidden: true,
              MenuID: PERMISSIONS.ACCESSRIGHT,
            },
            {
              id: "access-profiles",
              title: "a_accessProfiles",
              type: "item",
              url: "/access-management/access-profiles",
              hidden: true,
              MenuID: PERMISSIONS.ACCESSPROFILES,
            },
            {
              id: "access-cards",
              title: "a_accessCards",
              type: "item",
              url: "/access-management/access-cards",
              hidden: true,
              MenuID: PERMISSIONS.ACCESSCARDS,
            },
            {
              id: "persons",
              title: "a_persons",
              type: "item",
              url: "/access-management/persons",
              hidden: true,
              MenuID: PERMISSIONS.PERSONS,
            },
            // {
            //   id: 'zones-management',
            //   title: 'Zones management',
            //   type: 'item',
            //   url: '/access-management/zones-management'
            // MenuID: PERMISSIONS.SKYACCESSKEYS,
            // },
            // {
            //   id: 'antipass-back',
            //   title: 'Antipass back',
            //   type: 'item',
            //   url: '/access-management/antipass-back'
            // MenuID: PERMISSIONS.SKYACCESSKEYS,
            // }
          ],
        },

        {
          id: "User-management",
          title: "operatorManagement",
          type: "collapse",
          icon: "fa fa-users",
          MenuID: PERMISSIONS.OPERATORMANAGEMENT,
          hidden: true,
          children: [
            {
              id: "user-roles-permissions",
              title: "operatorRolesPermissions",
              type: "item",
              url: "/user-management/user-roles-permissions",
              hidden: true,
              MenuID: PERMISSIONS.ROLESPERMISSION,
            },
            {
              id: "user-assignements",
              title: "operatorAssignments",
              type: "item",
              url: "/user-management/user-assignments",
              hidden: true,
              MenuID: PERMISSIONS.OPERATORASSIGNMENT,
            },
            {
              id: "client-permissions",
              title: "clientRolesPermissions",
              type: "item",
              url: "/integra-clients/client-permissions",
              hidden: true,
              MenuID: PERMISSIONS.CLIENTROLESPERMISSION,
            },
            {
              id: "client-user-assignements",
              title: "clientAssignments",
              type: "item",
              url: "/integra-clients/client-user-assignements",
              hidden: true,
              MenuID: PERMISSIONS.CLIENTASSIGNMENT,
            },
            // {
            //   id: "integra-clients",
            //   title: "integraClients",
            //   type: "collapse",
            //   icon: "feather icon-layers",
            //   hidden: true,
            //   MenuID: PERMISSIONS.INTEGRACLIENTS,
            //   children: [
            //     {
            //       id: "client-permissions",
            //       title: "clientRolesPermissions",
            //       type: "item",
            //       url: "/integra-clients/client-permissions",
            //       hidden: true,
            //       MenuID: PERMISSIONS.CLIENTROLESPERMISSION,
            //     },
            //     {
            //       id: "client-user-assignements",
            //       title: "clientAssignments",
            //       type: "item",
            //       url: "/integra-clients/client-user-assignements",
            //       hidden: true,
            //       MenuID: PERMISSIONS.CLIENTASSIGNMENT,
            //     },
            //   ],
            // },
          ],
        },

        {
          id: "monitoring",
          title: "monitoring",
          type: "collapse",
          icon: "fa fa-industry",
          hidden: true,
          MenuID: PERMISSIONS.MONITORING,
          children: [
            {
              id: "door-monitoring",
              title: "m_doorMonitoring",
              type: "item",
              url: "/monitoring/door-monitoring",
              hidden: true,
              MenuID: PERMISSIONS.DOORMONITORING,
            },
            {
              id: "accesspoint-monitoring",
              title: "m_apMonitoring",
              type: "item",
              url: "/monitoring/accesspoint-monitoring",
              hidden: true,
              MenuID: PERMISSIONS.ACCESSPOINTMONITORING,
            },
            // {
            //   id: 'consumption-monitoring',
            //   title: 'Consumption monitoring',
            //   type: 'item',
            //   url: '/monitoring/consumption-monitoring'
            // MenuID: PERMISSIONS.CONSUMPTIONMONITORING,
            // },
            // {
            //   id: 'alarm-monitoring',
            //   title: 'Alarm monitoring',
            //   type: 'item',
            //   url: '/monitoring/alarm-monitoring'
            // MenuID: PERMISSIONS.ALARMMONITORING,
            // },
            // {
            //   id: 'zone-monitoring',
            //   title: 'Zone monitoring',
            //   type: 'item',
            //   url: '/Monitoring/zone-monitoring'
            // MenuID: PERMISSIONS.ZONEMONITORING,
            // },
            {
              id: "wireless-chart",
              title: "m_wirelessChart",
              type: "item",
              url: "/monitoring/wireless-chart",
              hidden: true,
              MenuID: PERMISSIONS.WIRELESSCHART,
            },
            {
              id: "battery-chart",
              title: "m_batteryChart",
              type: "item",
              url: "/monitoring/battery-chart",
              hidden: true,
              MenuID: PERMISSIONS.BATTERYCHART,
            },
          ],
        },

        {
          id: "communication-settings",
          title: "commSettings",
          type: "collapse",
          icon: "fa fa-sitemap",
          MenuID: PERMISSIONS.COMMUNICATIONSETTING,
          hidden: true,
          children: [
            {
              id: "pms-settings",
              title: "pmsSettings",
              type: "item",
              url: "/communication-settings/pms-settings",
              hidden: true,
              MenuID: PERMISSIONS.PMSSETTING,
            },
            // {
            //   id: 'wireless-settings',
            //   title: 'Wireless settings',
            //   type: 'item',
            //   url: '/communication-settings/wireless-settings'
            // MenuID: PERMISSIONS.WIRELESS,
            // },
            {
              id: "access-point-settings",
              title: "accessPointSettings",
              type: "item",
              url: "/communication-settings/access-point-settings",
              hidden: true,
              MenuID: PERMISSIONS.ACCESSPOINTSETTINGS,
            },
          ],
        },

        // {
        //   id: "calendar-management",
        //   title: "calendarMgt",
        //   type: "collapse",
        //   icon: "fa fa-history",
        //   MenuID: PERMISSIONS.CALENDARMANAgement,
        //   hidden: true,
        //   children: [
        //     {
        //       id: "calender",
        //       title: "c_calendar",
        //       type: "item",
        //       url: "/calender-management/calender",
        //       hidden: true,
        //       MenuID: PERMISSIONS.CALENDAR,
        //     },
        //     {
        //       id: "dsd",
        //       title: "c_dsd",
        //       type: "item",
        //       url: "/calender-management/dsd",
        //       hidden: true,
        //       MenuID: PERMISSIONS.DSD,
        //     },
        //     {
        //       id: "special-days",
        //       title: "c_specialDays",
        //       type: "item",
        //       url: "/calender-management/special-days",
        //       hidden: true,
        //       MenuID: PERMISSIONS.SPECIALDAYS,
        //     },
        //   ],
        // },

        {
          id: "events-log",
          title: "eventsLog",
          type: "collapse",
          icon: "fa fa-archive",
          hidden: true,
          MenuID: PERMISSIONS.EVENTLOG,
          children: [
            // {
            //   id: 'devices-auditories',
            //   title: 'Devices Auditories',
            //   type: 'item',
            //   url: '/events-log/devices-auditories'
            // MenuID: PERMISSIONS.DEVICEAUDITORIES,
            // },
            {
              id: "door-events",
              title: "e_doorEvents",
              type: "item",
              url: "/events-log/door-events",
              hidden: true,
              MenuID: PERMISSIONS.DOOREVENTS,
            },
            {
              id: "system-events",
              title: "e_systemEvents",
              type: "item",
              url: "/events-log/system-events",
              hidden: true,
              MenuID: PERMISSIONS.SYSTEMEVENTS,
            },
          ],
        },

        {
          id: "house-keeping",
          title: "houseKeeping",
          type: "collapse",
          icon: "fa fa-home",
          hidden: true,
          MenuID: PERMISSIONS.HOUSEKEEPING,
          children: [
            {
              id: "database-backup",
              title: "h_databaseBackup",
              type: "item",
              url: "/house-keeping/database-backup",
              hidden: true,
              MenuID: PERMISSIONS.DATABASEBACKUP,
            },
            {
              id: "system-events",
              title: "h_systemEvents",
              type: "item",
              url: "/house-keeping/system-events",
              hidden: true,
              MenuID: PERMISSIONS.SYSTEMEVENT,
            },
          ],
        },

        {
          id: "parking",
          title: "parking",
          type: "collapse",
          icon: "fa fa-car",
          hidden: true,
          MenuID: PERMISSIONS.PARKING,
          children: [
            {
              id: "issue-card",
              title: "p_issueCard",
              type: "item",
              url: "/reception/guest-management",
              hidden: true,
              MenuID: PERMISSIONS.ISSUECARD,
            },
            {
              id: "overview",
              title: "p_overview",
              type: "item",
              url: "/garage/second-menu",
              hidden: true,
              MenuID: PERMISSIONS.OVERVIEW,
            },
            {
              id: "event",
              title: "p_event",
              type: "item",
              url: "/events-log/door-events",
              hidden: true,
              MenuID: PERMISSIONS.EVENTS,
            },
          ],
        },
        {
          id: "client-buildings",
          title: "clientBuildings",
          type: "collapse",
          icon: "fa fa-th",
          hidden: true,
          //MenuID: PERMISSIONS.buildings,
          children: [
            {
              id: "management",
              title: "c_management",
              type: "item",
              url: "/client-buildings/management",
              hidden: true,
              //MenuID: PERMISSIONS.management,
            },
          ],
        },
      ],
    },
  ];

  public static NavigationItemsApp = [
    {
      id: "MyAmadeo",
      title: "MyAmadeo  Nav",
      type: "group",
      icon: "fa fa-th",
      children: [
        {
          id: "multi-properties",
          title: "Multi-properties",
          type: "collapse",
          icon: "feather icon-cloud",
          children: [],
        },
        {
          id: "home",
          title: "Home",
          type: "item",
          icon: "feather icon-home",
          url: "/hotel/welcome",
          classes: "nav-item",
          target: false,
          breadcrumbs: false,
        },
        {
          id: "hotel",
          title: "Hotel",
          type: "collapse",
          icon: "fa fa-building",
          children: [
            {
              id: "business-module-1000",
              title: "In House",
              type: "item",
              url: "/hotel/hotel-business/business-module-1000",
            },
            {
              id: "business-module-10000",
              title: "Rooms & Suites",
              type: "item",
              url: "/hotel/hotel-business/business-module-10000",
            },
            {
              id: "business-module-100000",
              title: "Restaurant",
              type: "item",
              url: "/hotel/hotel-business/business-module-100000",
            },
            {
              id: "business-module-2000",
              title: "Room Services",
              type: "item",
              url: "/hotel/hotel-business/business-module-2000",
            },
            {
              id: "business-module-20000",
              title: "Bar",
              type: "item",
              url: "/hotel/hotel-business/business-module-20000",
            },
            {
              id: "business-module-200000",
              title: "Fitness",
              type: "item",
              url: "/hotel/hotel-business/business-module-200000",
            },
            {
              id: "business-module-20000000",
              title: "SPA",
              type: "item",
              url: "/hotel/hotel-business/business-module-20000000",
            },
          ],
        },
        {
          id: "city-guide",
          title: "City Guide",
          type: "collapse",
          icon: "fa fa-city",
          children: [
            {
              id: "guide-module-1000",
              title: "Shopping",
              type: "item",
              url: "/cityguide/guides/guide-module-1000",
            },
            {
              id: "guide-module-10000",
              title: "Restaurants",
              type: "item",
              url: "/cityguide/guides/guide-module-10000",
            },
            {
              id: "guide-module-100000",
              title: "Night Life",
              type: "item",
              url: "/cityguide/guides/guide-module-100000",
            },
            {
              id: "guide-module-2000",
              title: "Kids Zones",
              type: "item",
              url: "/cityguide/guides/guide-module-2000",
            },
            {
              id: "guide-module-20000",
              title: "Neighborhood",
              type: "item",
              url: "/cityguide/guides/guide-module-20000",
            },
            {
              id: "guide-module-200000",
              title: "Must Know",
              type: "item",
              url: "/cityguide/guides/guide-module-200000",
            },
            {
              id: "guide-module-20000000",
              title: "Mechandises",
              type: "item",
              url: "/cityguide/guides/guide-module-20000000",
            },
          ],
        },
        {
          id: "facebook",
          title: "Facebook",
          type: "item",
          icon: "feather icon-facebook",
          url: "/hotel/facebook", // This link is updated by the application when the user provide the facebook page link
          classes: "nav-item",
          target: false,
          breadcrumbs: false,
          external: true,
        },
        {
          id: "twitter",
          title: "Twitter",
          type: "item",
          icon: "feather icon-twitter",
          url: "/hotel/twitter", // This link is updated by the application when the user provide the facebook page link
          classes: "nav-item",
          target: false,
          breadcrumbs: false,
          external: true,
        },
        {
          id: "instagram",
          title: "instagram",
          type: "item",
          icon: "feather icon-instagram",
          url: "/hotel/instagram",
          classes: "nav-item",
          target: false,
          breadcrumbs: false,
          external: true,
        },
      ],
    },
  ];

  public static NavigationItems2 = [
    {
      id: "navigation",
      title: "Navigation",
      type: "group",
      icon: "fa fa-th",
      children: [
        {
          id: "dashboard",
          title: "dashboard",
          type: "collapse",
          icon: "fa fa-th",
          children: [
            {
              id: "default",
              title: "d_default",
              type: "item",
              url: "/dashboard/default",
            },
            {
              id: "summary",
              title: "d_summary",
              type: "item",
              url: "/dashboard/summary",
            },
            {
              id: "crm",
              title: "d_skyAccess",
              type: "item",
              url: "/dashboard/crm",
            },
          ],
        },
        {
          id: "system",
          title: "system",
          type: "collapse",
          icon: "fa fa-cogs",
          children: [
            {
              id: "default-settings",
              title: "s_defaultSettings",
              type: "item",
              url: "/system/default-settings",
            },
            {
              id: "rfid-card-settings",
              title: "s_rfidCardSettings",
              type: "item",
              url: "/system/rfid-card-settings",
            },
          ],
        },
        {
          id: "skyaccess",
          title: "skyAccess",
          type: "collapse",
          icon: "fa fa-cloud",
          children: [
            {
              id: "hotel",
              title: "s_hotel",
              type: "item",
              url: "/skyaccess/hotel",
            },
            // {
            //   id: 'access-control',
            //   title: 'Access Control',
            //   type: 'item',
            //   url: '/skyaccess/access-control'
            // },
            // {
            //   id: "residential",
            //   title: "s_residential",
            //   type: "item",
            //   url: "/skyaccess/residential",
            // },
          ],
        },
        {
          id: "emails",
          title: "emailManagement",
          type: "collapse",
          icon: "fa fa-envelope",
          // badge: {
          //   title: '3',
          //   type: 'label-info'
          // },
          children: [
            {
              id: "email-templates",
              title: "e_emailTemplates",
              type: "item",
              url: "/emails/email-templates",
            },
            {
              id: "skyaccess-keys",
              title: "e_skyAccessKeys",
              type: "item",
              url: "/emails/skyaccess-keys",
            },
            // {
            //   id: 'alarms',
            //   title: 'Alarms and alert',
            //   type: 'item',
            //   url: '/emails/alarms'
            // },
            {
              id: "support-center",
              title: "e_supportCenter",
              type: "item",
              url: "/emails/support-center",
            },
          ],
        },

        {
          id: "hardware-templates",
          title: "hardwareTemplates",
          type: "collapse",
          icon: "fa fa-wrench",
          children: [
            {
              id: "ilock-template",
              title: "h_ilock",
              type: "item",
              url: "/hardware-templates/ilock-template",
            },
            {
              id: "wall-reader-template",
              title: "h_wallReader",
              type: "item",
              url: "/hardware-templates/wall-reader-template",
            },
            // {
            //   id: 'door-manager-template',
            //   title: 'h_doorManager',
            //   type: 'item',
            //   url: '/hardware-templates/door-manager-template'
            // },
            // {
            //   id: 'elevator-template',
            //   title: 'Elevator Template',
            //   type: 'item',
            //   url: '/hardware-templates/elevator-template'
            // },
            // {
            //   id: 'energy-saver-template',
            //   title: 'Energy saver Template',
            //   type: 'item',
            //   url: '/hardware-templates/energy-saver-template'
            // },
            // {
            //   id: 'silocker-template',
            //   title: 'Silocker Template',
            //   type: 'item',
            //   url: '/hardware-templates/silocker-template'
            // },
          ],
        },

        {
          id: "Doors Setups",
          title: "doorSetups",
          type: "collapse",
          icon: "fa fa-lock",
          children: [
            {
              id: "Services-Auth",
              title: "d_service",
              type: "item",
              url: "/doors-setups/services-auth",
            },
            {
              id: "door-scheduler",
              title: "d_doorScheduler",
              type: "item",
              url: "/doors-setups/door-scheduler",
            },
            {
              id: "door-weekly-program",
              title: "d_doorWeeklyProgram",
              type: "item",
              url: "/doors-setups/door-weekly-program",
            },
            {
              id: "door-management",
              title: "d_doorManagement",
              type: "item",
              url: "/doors-setups/door-management",
            },
            // {
            //   id: 'door-groups',
            //   title: 'Door Groups',
            //   type: 'item',
            //   url: '/doors-setups/door-groups'
            // },
            {
              id: "door-relationship",
              title: "d_doorRelationship",
              type: "item",
              url: "/doors-setups/door-relationship",
            },
          ],
        },

        {
          id: "reception",
          title: "reception",
          type: "collapse",
          icon: "fa fa-key",
          children: [
            {
              id: "guest-checkin",
              title: "r_guestCheckin",
              type: "item",
              url: "/reception/guest-checkin",
            },
            {
              id: "new-guest-check-in",
              title: "r_newGuestCheckin",
              type: "item",
              url: "/reception/re-rooming",
              // badge: {
              //       title: 'NEW',
              //       type: 'label-danger'
              //     }
            },
            {
              id: "guest-management",
              title: "r_guestMgt",
              type: "item",
              url: "/reception/checked-in-guest",
            },
            {
              id: "on-door-check-in",
              title: "r_onDoorCheckin",
              type: "item",
              url: "/reception/on-door-check-in",
            },
            {
              id: "lost-block-cards",
              title: "r_lostBlockCards",
              type: "item",
              url: "/reception/lost-block-cards",
            },
          ],
        },

        {
          id: "staff",
          title: "staff",
          type: "collapse",
          icon: "fas fa-users",
          children: [
            {
              id: "staff-management",
              title: "s_staffMgt",
              type: "item",
              url: "/reception/staff-management",
            },
            {
              id: "staff-lost-block-cards",
              title: "s_lostBlockCards",
              type: "item",
              url: "/reception/staff-lost-block-cards",
            },
          ],
        },

        {
          id: "access-management",
          title: "accessMgt",
          type: "collapse",
          icon: "fa fa-id-card",
          children: [
            {
              id: "access-rights",
              title: "a_accessRights",
              type: "item",
              url: "/access-management/access-rights",
            },
            {
              id: "access-profiles",
              title: "a_accessProfiles",
              type: "item",
              url: "/access-management/access-profiles",
            },
            {
              id: "persons",
              title: "a_persons",
              type: "item",
              url: "/access-management/persons",
            },
            {
              id: "access-cards",
              title: "a_accessCards",
              type: "item",
              url: "/access-management/access-cards",
            },
            // {
            //   id: 'zones-management',
            //   title: 'Zones management',
            //   type: 'item',
            //   url: '/access-management/zones-management'
            // },
            // {
            //   id: 'antipass-back',
            //   title: 'Antipass back',
            //   type: 'item',
            //   url: '/access-management/antipass-back'
            // }
          ],
        },

        {
          id: "User-management",
          title: "operatorManagement",
          type: "collapse",
          icon: "fa fa-users",
          children: [
            {
              id: "user-roles-permissions",
              title: "operatorRolesPermissions",
              type: "item",
              url: "/user-management/user-roles-permissions",
            },
            {
              id: "user-assignements",
              title: "operatorAssignments",
              type: "item",
              url: "/user-management/user-assignments",
            },
            {
              id: "integra-clients",
              title: "integraClients",
              type: "collapse",
              icon: "feather icon-layers",
              children: [
                {
                  id: "client-permissions",
                  title: "clientRolesPermissions",
                  type: "item",
                  url: "/integra-clients/client-permissions",
                },
                {
                  id: "client-user-assignements",
                  title: "clientAssignments",
                  type: "item",
                  url: "/integra-clients/client-user-assignements",
                },
              ],
            },
          ],
        },

        {
          id: "monitoring",
          title: "monitoring",
          type: "collapse",
          icon: "fa fa-industry",
          children: [
            {
              id: "door-monitoring",
              title: "m_doorMonitoring",
              type: "item",
              url: "/monitoring/door-monitoring",
            },
            {
              id: "accesspoint-monitoring",
              title: "m_apMonitoring",
              type: "item",
              url: "/monitoring/accesspoint-monitoring",
            },
            // {
            //   id: 'consumption-monitoring',
            //   title: 'Consumption monitoring',
            //   type: 'item',
            //   url: '/monitoring/consumption-monitoring'
            // },
            // {
            //   id: 'alarm-monitoring',
            //   title: 'Alarm monitoring',
            //   type: 'item',
            //   url: '/monitoring/alarm-monitoring'
            // },
            // {
            //   id: 'zone-monitoring',
            //   title: 'Zone monitoring',
            //   type: 'item',
            //   url: '/Monitoring/zone-monitoring'
            // },
            {
              id: "wireless-chart",
              title: "m_wirelessChart",
              type: "item",
              url: "/monitoring/wireless-chart",
            },
            {
              id: "battery-chart",
              title: "m_batteryChart",
              type: "item",
              url: "/monitoring/battery-chart",
            },
          ],
        },

        {
          id: "communication-settings",
          title: "commSettings",
          type: "collapse",
          icon: "fa fa-sitemap",
          children: [
            {
              id: "pms-settings",
              title: "pmsSettings",
              type: "item",
              url: "/communication-settings/pms-settings",
            },
            // {
            //   id: 'wireless-settings',
            //   title: 'Wireless settings',
            //   type: 'item',
            //   url: '/communication-settings/wireless-settings'
            // },
            {
              id: "access-point-settings",
              title: "accessPointSettings",
              type: "item",
              url: "/communication-settings/access-point-settings",
            },
          ],
        },

        {
          id: "calendar-management",
          title: "calendarMgt",
          type: "collapse",
          icon: "fa fa-history",
          children: [
            {
              id: "calender",
              title: "c_calendar",
              type: "item",
              url: "/calender-management/calender",
            },
            {
              id: "dsd",
              title: "c_dsd",
              type: "item",
              url: "/calender-management/dsd",
            },
            {
              id: "special-days",
              title: "c_specialDays",
              type: "item",
              url: "/calender-management/special-days",
            },
          ],
        },

        {
          id: "events-log",
          title: "eventsLog",
          type: "collapse",
          icon: "fa fa-archive",
          children: [
            // {
            //   id: 'devices-auditories',
            //   title: 'Devices Auditories',
            //   type: 'item',
            //   url: '/events-log/devices-auditories'
            // },
            {
              id: "door-events",
              title: "e_doorEvents",
              type: "item",
              url: "/events-log/door-events",
            },
            {
              id: "system-events",
              title: "e_systemEvents",
              type: "item",
              url: "/events-log/system-events",
            },
          ],
        },

        {
          id: "house-keeping",
          title: "houseKeeping",
          type: "collapse",
          icon: "fa fa-home",
          children: [
            {
              id: "database-backup",
              title: "h_databaseBackup",
              type: "item",
              url: "/house-keeping/database-backup",
            },
            {
              id: "system-events",
              title: "h_systemEvents",
              type: "item",
              url: "/house-keeping/system-events",
            },
          ],
        },

        {
          id: "parking",
          title: "parking",
          type: "collapse",
          icon: "fa fa-car",
          children: [
            {
              id: "issue-card",
              title: "p_issueCard",
              type: "item",
              url: "/reception/guest-management",
            },
            {
              id: "overview",
              title: "p_overview",
              type: "item",
              url: "/garage/second-menu",
            },
            {
              id: "event",
              title: "p_event",
              type: "item",
              url: "/events-log/door-events",
            },
          ],
        },
        {
          id: "client-buildings",
          title: "clientBuildings",
          type: "collapse",
          icon: "fa fa-th",
          children: [
            {
              id: "management",
              title: "c_management",
              type: "item",
              url: "/client-buildings/management",
            },
          ],
        },
      ],
    },
  ];

  public static GetWorkingMenus(Permissions: [{ _Permission: PERMISSIONS }]) {
    /*  Comment the menus below to allow them to show if the user is authorized  */
    let Perms = [];

    // //Perms.push({ _Permission: PERMISSIONS.DOORSETUP });
    // //Perms.push({ _Permission: PERMISSIONS.SERVICEAUTH });
    // //Perms.push({ _Permission: PERMISSIONS.DOORSCHEDULER });
    // //Perms.push({ _Permission: PERMISSIONS.DOORWEKKLYPROGRAM });
    // Perms.push({ _Permission: PERMISSIONS.DOORMANAGEMENT });
    // //Perms.push({ _Permission: PERMISSIONS.DOORRELATIONSHIP });

    // Perms.push({ _Permission: PERMISSIONS.HARDWARETEMPLATE });
    // Perms.push({ _Permission: PERMISSIONS.ILOCKTEMPLATE });
    // Perms.push({ _Permission: PERMISSIONS.WALLREADER });

    // Perms.push({ _Permission: PERMISSIONS.DASHBOARD });
    // Perms.push({ _Permission: PERMISSIONS.DEFAULT });
    // Perms.push({ _Permission: PERMISSIONS.SUMMARY });
    // Perms.push({ _Permission: PERMISSIONS.SKYACCESS });

    // Perms.push({ _Permission: PERMISSIONS.RFIDSETTING });

    // Perms.push({ _Permission: PERMISSIONS.SKYACCESSMOBILE });
    // Perms.push({ _Permission: PERMISSIONS.HOTEL });

    // Perms.push({ _Permission: PERMISSIONS.SKYACCESSKEYS });
    // Perms.push({ _Permission: PERMISSIONS.SUPPORTCENTER });

    //  Perms.push({ _Permission: PERMISSIONS.REROOM });

    //  Perms.push({ _Permission: PERMISSIONS.ONDOORCHECKIN });

    // // //Guest mngt
    //  Perms.push({ _Permission: PERMISSIONS.LOSTBLOCKCARD });
    // //Perms.push({ _Permission: PERMISSIONS.GUESTCARDMANGEMENT });

    // // // Staff mngt
    //  Perms.push({ _Permission: PERMISSIONS.LOSTBLOCKCARDS });

    //  Perms.push({ _Permission: PERMISSIONS.ACCESSMANAGEMENT });
    //  Perms.push({ _Permission: PERMISSIONS.ACCESSRIGHT });
    //  Perms.push({ _Permission: PERMISSIONS.ACCESSPROFILES });
    //  Perms.push({ _Permission: PERMISSIONS.PERSONS });
    //  Perms.push({ _Permission: PERMISSIONS.ACCESSCARDS });

    //  Perms.push({ _Permission: PERMISSIONS.OPERATORMANAGEMENT });
    //  Perms.push({ _Permission: PERMISSIONS.ROLESPERMISSION });
    //  Perms.push({ _Permission: PERMISSIONS.OPERATORASSIGNMENT });
    //  Perms.push({ _Permission: PERMISSIONS.CLIENTROLESPERMISSION });
    //  Perms.push({ _Permission: PERMISSIONS.CLIENTASSIGNMENT });

    //  Perms.push({ _Permission: PERMISSIONS.MONITORING });
    //  Perms.push({ _Permission: PERMISSIONS.DOORMONITORING });
    //  Perms.push({ _Permission: PERMISSIONS.ACCESSPOINTMONITORING });
    //  Perms.push({ _Permission: PERMISSIONS.WIRELESSCHART });
    //  Perms.push({ _Permission: PERMISSIONS.BATTERYCHART });

    //  Perms.push({ _Permission: PERMISSIONS.COMMUNICATIONSETTING });
    //  Perms.push({ _Permission: PERMISSIONS.PMSSETTING });
    //  Perms.push({ _Permission: PERMISSIONS.ACCESSPOINTSETTINGS });

    Perms.push({ _Permission: PERMISSIONS.MANAGEMENT });
    Perms.push({ _Permission: PERMISSIONS.PARKING });
    Perms.push({ _Permission: PERMISSIONS.EVENTS });
    Perms.push({ _Permission: PERMISSIONS.OVERVIEW });
    Perms.push({ _Permission: PERMISSIONS.ISSUECARD });

    //  Perms.push({ _Permission: PERMISSIONS.HOUSEKEEPING });
    //  Perms.push({ _Permission: PERMISSIONS.DATABASEBACKUP });
    //  Perms.push({ _Permission: PERMISSIONS.SYSTEMEVENT });

    //  Perms.push({ _Permission: PERMISSIONS.CALENDARMANAgement });
    //  Perms.push({ _Permission: PERMISSIONS.CALENDAR });
    //  Perms.push({ _Permission: PERMISSIONS.DSD });
    //  Perms.push({ _Permission: PERMISSIONS.SPECIALDAYS });

    Array.from(Permissions).forEach((Perm1) => {
      Array.from(Perms).forEach((Perm2) => {
        if (Perm1._Permission === Perm2._Permission) {
          Permissions.splice(Permissions.indexOf(Perm1), 1);
        }
      });
    });

    return Permissions;
  }

  public static FilterMenuWithPermissions(
    Permissions: [{ _Permission: PERMISSIONS }]
  ) {
    let urls = [];

    Permissions = this.GetWorkingMenus(Permissions);

    for (
      var i = 0;
      i < (NavigationItem.NavigationItems as Navigation[])[0].children.length;
      i++
    ) {
      for (
        var j = 0;
        j <
        (NavigationItem.NavigationItems as Navigation[])[0].children[i].children
          .length;
        j++
      ) {
        Array.from(Permissions).forEach((Perm) => {
          if (
            Perm._Permission ==
            (NavigationItem.NavigationItems as Navigation[])[0].children[i]
              .MenuID
          ) {
            (NavigationItem.NavigationItems as Navigation[])[0].children[
              i
            ].hidden = false;
          }

          if (
            Perm._Permission ==
            (NavigationItem.NavigationItems as Navigation[])[0].children[i]
              .children[j].MenuID
          ) {
            (NavigationItem.NavigationItems as Navigation[])[0].children[
              i
            ].children[j].hidden = false;
            let navLink = (NavigationItem.NavigationItems as Navigation[])[0]
              .children[i].children[j].url;
            //urls.push(navLink);
            urls.push("/reception/guest-checkin");
          }

          if (
            (NavigationItem.NavigationItems as Navigation[])[0].children[i]
              .children[j].children
          ) {
            for (
              var k = 0;
              k <
              (NavigationItem.NavigationItems as Navigation[])[0].children[i]
                .children[j].children?.length;
              k++
            ) {
              if (
                Perm._Permission ==
                (NavigationItem.NavigationItems as Navigation[])[0].children[i]
                  .children[j].children[k].MenuID
              ) {
                (NavigationItem.NavigationItems as Navigation[])[0].children[
                  i
                ].children[j].children[k].hidden = false;
              }
            }
          }
        });
      }
    }

    return urls;
  }

  public static GetAllPermissions(
    UserInfo: any,
    ReturnRoles: boolean = false
  ): any {
    let Permissions = [];
    let Roles = [];

    Array.from(UserInfo?.AppCLientPersonRoles).forEach((Role: any) => {
      Roles.push(Role);
      Array.from(Role.Permission).forEach((Perm) => {
        Permissions.push(Perm);
      });
    });

    if (!ReturnRoles) return Permissions;
    else return { _Roles: Roles, _Permissions: Permissions };
  }

  get() {
    let user = JSON.parse(atob(sessionStorage.getItem("userInfo")));
    NavigationItem.FilterMenuWithPermissions(
      NavigationItem.GetAllPermissions(user as any) as any
    );
    return NavigationItem.NavigationItems;

    //return NavigationItem.NavigationItems2;
  }

  getApp() {
    // return NavigationItem.NavigationItemsApp;
  }
}
